import { useEffect, useState } from "react";
import { deleteStripeCard, getStripeCardDetails } from "../api/apiFunctions";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteCardModal from "../components/Modals/DeleteCardModal";
import PaymentMethodCard from "../components/PaymentMethodCard";

const ManageCard = () => {
  const [savedCard, setSavedCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDeletingCard, setIsDeletingCard] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();

  const handleDeleteCard = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleCardDelete = async () => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    try {
      setIsDeletingCard(true);
      const response = await deleteStripeCard(token);
      if (response.success) {
        toast.success(response.message || "Card deleted successfully");
        setSavedCard(null);
        handleCloseDeleteModal();
      }
    } catch (error) {
      console.log("Error deleting card", error);
      handleCloseDeleteModal();
    } finally {
      setIsDeletingCard(false);
    }
  };

  const handleAddCard = () => {
    navigate("/add-card");
  };

  useEffect(() => {
    const getCardDetails = async () => {
      const token =
        localStorage.getItem("authToken") ||
        sessionStorage.getItem("authToken");
      try {
        setLoading(true);
        const card = await getStripeCardDetails(token);
        setSavedCard(card.cardDetails);
      } catch (error) {
        console.log("Error fetching card details", error);
      } finally {
        setLoading(false);
      }
    };
    getCardDetails();
  }, []);

  if (loading) {
    return (
      <div className="h-full flex items-center justify-center">
        <p className="text-gray-500">Loading Card...</p>
      </div>
    );
  }

  return (
    <div className="h-full bg-gradient-to-br from-[#f7f8fa] to-[#e8eaf0] p-4 py-8">
      {savedCard ? (
        <div className="max-w-5xl mx-auto">
          <h1 className="md:text-3xl text-xl font-extrabold text-[#2d348f]">
            Payment Method
          </h1>
          <p className="text-[#837f90] mb-4 md:mb-8">
            Manage your billing card for subscription
          </p>
          <div className="max-w-sm">
            {/* Card */}
            <PaymentMethodCard
              savedCard={savedCard}
              onDelete={handleDeleteCard}
              isDeletingCard={isDeletingCard}
            />
          </div>
        </div>
      ) : (
        <div className="max-w-md p-12 text-center flex flex-col items-center justify-center mx-auto bg-white rounded-2xl">
          <div className="bg-gradient-to-br from-[#f7f8fa] to-[#e8eaf0] rounded-full p-6 w-24 h-24 mx-auto mb-6 flex items-center justify-center">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2d348f"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-[#2d348f] mb-2">
            No Saved Card
          </h3>
          <p className="text-[#837f90] mb-6">
            Add a payment method to manage subscriptions and billing.
          </p>
          <button
            onClick={handleAddCard}
            className="w-full py-3 px-6 font-bold text-white text-base bg-gradient-to-r from-[#445eed] to-[#2d348f] hover:from-[#3916ab] hover:to-[#4962d8] transition-all rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]"
          >
            Add Card
          </button>
        </div>
      )}
      {/* Delete Card Modal */}
      <DeleteCardModal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onDelete={handleCardDelete}
        isDeletingCard={isDeletingCard}
      />
    </div>
  );
};

export default ManageCard;
